import { fromJS } from 'immutable';
import handleAction from '../common/utils/handle-action.js';
import simpleReducer from '../common/utils/simple-reducer.js';
import {
  RESPOND_TO_CLI_ERROR,
  SET_ACCESS_TOKEN,
  SET_CLI_LOGIN_TOKEN,
  SET_EMAIL_REQUIRES_EMAIL_VALIDATION,
  UPDATE_USER
} from './action-types';
import { changePassword, createUser, getUser, loginUser, logoutUser } from './actions.js';
import { AuthState } from './state.js';

export const initialState = new AuthState();

const getUserHandlers = {
  PENDING(state) {
    return state.merge({
      userLoading: true,
      userError: null
    });
  },
  FULFILLED(state, { payload }) {
    return state.merge({
      user: fromJS(payload.data),
      userLoading: false,
      userLoaded: true,
      userError: null
    });
  },
  REJECTED(state, { payload }) {
    return state.merge({
      userLoading: false,
      userLoaded: false,
      userError: payload.message
    });
  }
};

const updateUserHandlers = {
  PENDING(state) {
    return state.merge({
      userUpdating: true
    });
  },
  FULFILLED(state, { payload }) {
    return state.mergeIn(['user'], fromJS(payload)).set('userUpdating', false);
  },
  REJECTED(state) {
    return state.merge({
      userUpdating: false
    });
  }
};

export default simpleReducer(initialState, {
  [getUser.PENDING]: getUserHandlers.PENDING,
  [getUser.FULFILLED]: getUserHandlers.FULFILLED,
  [getUser.REJECTED]: getUserHandlers.REJECTED,
  [createUser.PENDING](state) {
    return state.merge({
      userCreating: true,
      userCreated: false,
      userError: null
    });
  },
  [createUser.FULFILLED](state, { payload }) {
    return state.merge({
      user: fromJS(payload.data),
      userLoading: false,
      userLoaded: true,
      userError: null
    });
  },
  [createUser.REJECTED](state, { payload }) {
    return state.merge({
      userCreating: false,
      userCreated: false,
      userError: payload.message
    });
  },
  ...handleAction(UPDATE_USER, updateUserHandlers),
  [changePassword.PENDING]: updateUserHandlers.PENDING,
  [changePassword.FULFILLED]: updateUserHandlers.FULFILLED,
  [changePassword.REJECTED]: updateUserHandlers.REJECTED,
  [loginUser.PENDING]: getUserHandlers.PENDING,
  [loginUser.FULFILLED]: getUserHandlers.FULFILLED,
  [loginUser.REJECTED]: getUserHandlers.REJECTED,
  [logoutUser.FULFILLED]() {
    return initialState;
  },
  [RESPOND_TO_CLI_ERROR](state) {
    return state.set('respondToCliError', true);
  },
  [SET_CLI_LOGIN_TOKEN](state, { payload }) {
    return state.set('cliLoginToken', payload);
  },
  [SET_ACCESS_TOKEN](state, { payload }) {
    return state.set('accessToken', payload);
  },
  [SET_EMAIL_REQUIRES_EMAIL_VALIDATION](state, { payload }) {
    return state.setIn(['user', 'requiresEmailValidation'], payload);
  }
});
